// © 2015-2021 WDNA - All Rights Reserved

import _ from 'lodash';
import * as React from 'react';

import Select2, { DataSelect2 } from 'wdna-select2';

import { TypeSensorVariableDO, VariableDO } from '../../../requests';

interface Props {
  formValues: {
    variableArray: VariableDO[];
    data: Partial<TypeSensorVariableDO>;
  };
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

/**
 * Function to generate a form component
 *
 * @param props properties of the component
 * @returns jsx element with the form
 */
export default function Form(props: Props): JSX.Element {
  const { variableArray, data } = props.formValues;

  return (
    <fieldset>
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Variable</b> &nbsp;
          </label>
          <span className="mandatory">
            <Select2
              id="data.variableId"
              name="data.variableId"
              value={_.defaultTo(data.variableId, '')}
              onChange={props.onChange}
              data-ctype="number"
              data={variableArray.map((item: VariableDO): DataSelect2 => {
                return { id: item.id, text: item.name };
              })}
              options={{ placeholder: 'Select option' }}
              style={{ width: '80%' }}
              required
            />
          </span>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Order</b> &nbsp;
          </label>
          <input
            type="number"
            id="data.order"
            name="data.order"
            value={_.defaultTo(data.order, '')}
            onChange={props.onChange}
            data-ctype="number"
            className="input-mandatory"
            style={{ width: '80%' }}
            placeholder="Order"
            required
          />
        </div>
        <div className="col-6">
          <label className="label">
            <b>Bytes</b> &nbsp;
          </label>
          <input
            type="number"
            id="data.bytes"
            name="data.bytes"
            value={data.bytes || '0'}
            onChange={props.onChange}
            data-ctype="number"
            className="input-mandatory"
            style={{ width: '80%' }}
            placeholder="Bytes"
            required
            pattern="[0-9]+"
            min="0"
          />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Formula</b> &nbsp; <br />
            Use a dollar symbol followed by the letter B and a number to use the value of a byte. <br />
            Example: $B0*256+$B1
          </label>
          <input
            type="text"
            id="data.formula"
            name="data.formula"
            value={_.defaultTo(data.formula, '')}
            onChange={props.onChange}
            className="input-new"
            style={{ width: '80%' }}
          />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Adjust if less than:</b> &nbsp;
          </label>
          <input
            type="number"
            id="data.adjustMin"
            name="data.adjustMin"
            value={_.defaultTo(data.adjustMin, '')}
            onChange={props.onChange}
            data-ctype="number"
            className="input-new"
            style={{ width: '80%' }}
          />
        </div>
        <div className="col-6">
          <label className="label">
            <b>Adjust if greater than:</b> &nbsp;
          </label>
          <input
            type="number"
            id="data.adjustMax"
            name="data.adjustMax"
            value={_.defaultTo(data.adjustMax, '')}
            onChange={props.onChange}
            data-ctype="number"
            className="input-new"
            style={{ width: '80%' }}
          />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Discard if less than:</b> &nbsp;
          </label>
          <input
            type="number"
            id="data.discardMin"
            name="data.discardMin"
            value={_.defaultTo(data.discardMin, '')}
            onChange={props.onChange}
            data-ctype="number"
            className="input-new"
            style={{ width: '80%' }}
          />
        </div>
        <div className="col-6">
          <label className="label">
            <b>Discard if greater than:</b> &nbsp;
          </label>
          <input
            type="number"
            id="data.discardMax"
            name="data.discardMax"
            value={_.defaultTo(data.discardMax, '')}
            onChange={props.onChange}
            className="input-new"
            style={{ width: '80%' }}
          />
        </div>
      </div>
    </fieldset>
  );
}
